import React from 'react';
import _ from 'lodash';
import {
  CakeIcon,
  DocumentDuplicateIcon,
  EnvelopeIcon,
  EyeIcon,
  LightBulbIcon,
  ShareIcon,
  TrashIcon
} from '@heroicons/react/24/outline';
import { useUser } from '@lore/auth';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import useDialogRouter from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';
import TabBarButton from '../../@communityshare/ui/navigation/TabBarButton';
import TabBar from '../../@communityshare/ui/navigation/TabBar';
import TabBarDropdownMenu from '../../@communityshare/ui/navigation/TabBarDropdownMenu';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../DialogManager';

export default function OfferTabBar(props) {
  const { offer } = props;

  const currentUser = useUser();

  const { id } = useDialogConfig();
  const router = useDialogRouter(id);

  const launch = useDialogLauncher();

  const buttonLinks = _.remove([
    {
      icon: LightBulbIcon,
      label: 'Idea',
      to: `/idea`
    },
    {
      icon: ShareIcon,
      label: 'Connect',
      to: `/invitations`
    }
  ], entry => entry);

  const menuLinks = _.remove([
    {
      type: 'button',
      icon: EnvelopeIcon,
      label: 'Send reminder to invite more educators',
      onClick: () => launch(DialogManager.ReminderOfferInvite.Config(offer.id)),
      active: false
    },
    {
      type: 'button',
      icon: EnvelopeIcon,
      label: 'Send reminder to finish describing offer',
      onClick: () => launch(DialogManager.ReminderOfferComplete.Config(offer.id)),
      active: false
    },
    {
      type: 'button',
      icon: EyeIcon,
      label: 'Change Visibility',
      onClick: () => launch(DialogManager.OfferVisibility.Config(offer.id)),
      active: false
    },
    {
      type: 'button',
      icon: DocumentDuplicateIcon,
      label: 'Assign to Steward',
      onClick: () => launch(DialogManager.OfferAssign.Config(offer.id)),
      active: false
    },
    {
      type: 'button',
      icon: TrashIcon,
      label: 'Delete offer',
      onClick: () => launch(DialogManager.OfferDelete.Config(offer.id)),
      active: false
    }
  ], entry => entry);

  return (
    <TabBar>
      {buttonLinks.map(function(link, index) {
        const active = (
          router.location.pathname.indexOf(link.to) === 0 ||
          link.to.indexOf(router.location.pathname) === 0
        );

        return (
          <TabBarButton
            key={index}
            active={active}
            onClick={() => router.navigate(link.to)}
            icon={link.icon}
            label={link.label}
            to={link.to}
          />
        );
      })}
      {currentUser.data.isSuperuser && (
        <TabBarDropdownMenu
          label="More actions"
          secret={true}
          links={menuLinks}
        />
      )}
    </TabBar>
  );
};
